<div class="report-container">
  <header class="report-header">
    <h3 class="report-title">Pré-visualização do Relatório</h3>
    <div class="report-actions">
      <button class="btn btn-download" (click)="downloadPdf()">
        <span class="icon">📥</span> Baixar PDF
      </button>
      <button class="btn btn-close" (click)="close()">Sair</button>
    </div>
  </header>

  <main class="report-viewer">
    <iframe *ngIf="pdfSafeUrl" [src]="pdfSafeUrl" frameborder="0"></iframe>
  </main>
</div>